module.exports = __webpack_public_path__ + "img/bg_floor_1.52049180.png";